import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { reports } from '../data/mock';
import '../styles/pages.css';
import usePageMeta from '../hooks/usePageMeta';

const Reports = () => {
  usePageMeta({
    title: 'Reportes',
    description: 'Reporte técnico y reporte ejecutivo con evidencia documentada, semáforo de riesgo y recomendaciones accionables por criterio.',
    path: '/reports',
  });

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Reportes y Entregables</h1>
          <p>Documentación profesional que respalda cada etapa del proceso</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="intro-content">
            <p className="lead-text">
              La documentación es un pilar fundamental de nuestra metodología. 
              Cada análisis, evaluación y recomendación queda registrada en reportes 
              profesionales que facilitan la toma de decisiones y la mejora continua.
            </p>
          </div>
        </div>
      </section>

      {/* Reports List */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Tipos de Reportes</h2>
          </div>
          <div className="reports-grid">
            {reports.map((report, index) => (
              <div key={report.id} className="report-card">
                <div className="report-icon">
                  <FileText size={24} />
                </div>
                <div className="report-number">{String(index + 1).padStart(2, '0')}</div>
                <h3>{report.title}</h3>
                <p>{report.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note */}
      <section className="section">
        <div className="container">
          <div className="info-box">
            <h3>Confidencialidad</h3>
            <p>
              Todos nuestros reportes son tratados con estricta confidencialidad. 
              La información contenida en los documentos es propiedad del cliente 
              y se maneja bajo protocolos de seguridad de la información.
            </p>
            <p>
              Los ejemplos y estructuras mostrados en esta sección son de carácter 
              ilustrativo. El contenido real de cada reporte se adapta a las 
              necesidades específicas del evento y del cliente.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Solicite más información</h2>
            <p>
              Conozca en detalle qué incluye cada tipo de reporte y cómo 
              puede beneficiar a su evento.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Contactar
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Reports;
